const hasCyrillic = (str: string): boolean => {
  return /[а-яА-ЯёЁ]/.test(str);
};

export const isAlreadyEncoded = (str: string): boolean => {
  try {
    return decodeURIComponent(str) !== str && !hasCyrillic(str);
  } catch {
    return false;
  }
};

const isAlreadyDecoded = (str: string): boolean => {
  try {
    return encodeURIComponent(str) !== str && hasCyrillic(str);
  } catch {
    return false;
  }
};

export const safeEncodeURIComponent = (str: string): string => {
  try {
    return isAlreadyEncoded(str) ? str : encodeURIComponent(str);
  } catch {
    // Fallback to encodeURI for Cyrillic characters
    return encodeURI(str);
  }
};

export const safeDecodeURIComponent = (str: string): string => {
  try {
    return isAlreadyDecoded(str) ? str : decodeURIComponent(str);
  } catch {
    // Fallback to decodeURI for Cyrillic characters
    return decodeURI(str);
  }
};
